import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { fromEvent, merge, of, timer, Observable } from 'rxjs';
import { map, switchMap, retry, catchError } from 'rxjs/operators';
import { UtilitiesService } from '../../services/utilities.service';

@Component({
    selector: 'app-offline-detector',
    imports: [
        CommonModule,
    ],
    standalone: true,
    templateUrl: './offline-detector.component.html',
    styleUrl: './offline-detector.component.scss',
})
export class OfflineDetectorComponent implements OnInit {
    private _utilitiesService = inject(UtilitiesService);

    heartbeat$ = new Observable<boolean>(observer => {
        const image = new Image();
        image.onload = () => {
            observer.next(true);
            observer.complete();
        };
        image.onerror = () => {
            observer.error(false);
        };
        image.src = `https://authors.crewfiction.com/pixel.png?t=${Date.now()}`;
    }).pipe(
        retry({ count: 2, delay: 1000 }),
        catchError(() => of(false))
    );

    isOnline$ = merge(
        of(navigator.onLine),
        fromEvent(window, 'online').pipe(map(() => true)),
        fromEvent(window, 'offline').pipe(map(() => false)),
        timer(0, 10_000).pipe(
            switchMap(() => this.heartbeat$)
        )
    );

    ngOnInit(): void {
        this._utilitiesService.preloadImage("/fluff.png");
    }
}